import { useTranslation } from "react-i18next";

import { CUSTOM_CONFIRM_TYPES, CustomConfirm } from "components";
import "modules/DealerDocumentations/components/AddEditDealerDocumentationModal/AddEditDealerDocumentationModal.scss";
import { useDeleteDocumentationMutation } from "modules/DealerDocumentations/components/AddEditDealerDocumentationModal/hooks";

import type { DealerDocumentation } from "models";

type AddEditDealerDocumentationModalCustomConfirmProps = {
  documentation: DealerDocumentation;
  showDeleteConfirmation: boolean;
  setShowDeleteConfirmation: React.Dispatch<React.SetStateAction<boolean>>;
  handleSetShowAddEditDealerDocumentationModal: (value: DealerDocumentation | null) => void;
};

export const AddEditDealerDocumentationModalCustomConfirm = ({
  documentation,
  setShowDeleteConfirmation,
  showDeleteConfirmation,
  handleSetShowAddEditDealerDocumentationModal
}: AddEditDealerDocumentationModalCustomConfirmProps) => {
  const { t } = useTranslation();

  const { mutate: deleteDocumentation, isPending: isDeleting } = useDeleteDocumentationMutation();

  const handleConfirm = () => deleteDocumentation(documentation.id, { onSuccess: () => handleSetShowAddEditDealerDocumentationModal(null) });

  return (
    <CustomConfirm
      handleConfirm={handleConfirm}
      handleCancel={() => setShowDeleteConfirmation(false)}
      isLoading={isDeleting}
      isOpen={showDeleteConfirmation}
      type={CUSTOM_CONFIRM_TYPES.Danger}
      confirmMsg={t("v8_delete_confirm_message", "Are you sure that you want to delete this? You can't undo this action.")}
    />
  );
};
